import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import { Badge } from "antd";
import StandardTableLayout from "../../layouts/StandardTableLayout/StandardTableLayout";
import StandardListLayout from "../../layouts/StandardTableLayout/StandardListLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  FETCH_ALL_MEMBER_POSITION_IN_ORGANISATION,
  setMemberPositions,
  DELETING_MEMBER_POSITION,
} from "../../store/team-member-store/reducer";

const Positions = () => {
  const dispatch = useDispatch();
  const { organisationId } = useSelector(({ auth }) => auth.user);
  const { csvExportData } = useSelector(({ user }) => user.userReducer);
  const { memberPositions } = useSelector(({ team }) => team.teamReducer);
  const [dataList, setDataList] = useState([]);

  const [csv, setCsv] = useState({
    headers: [
      {
        label: "Description",
        key: "description",
      },
      {
        label: "Status",
        key: "status",
      },
    ],
    data: [],
    fileName: "allPositions.csv",
  });
  const [isLoading, setIsLoading] = useState(true);
  const columns = [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let type = status === true ? "success" : "error";
        return <Badge status={type} text={status ? "Active" : "InActive"} />;
      },
      sorter: (a, b) => b.status - a.status,
    },
  ];

  const handleColumnCsv = (array) => {
    let csvData = [];
    array.forEach((e) => {
      csvData.push({
        code: e.code,
        title: e.title,
        status: e.status,
      });
    });
    return csvData;
  };

  const FETCH_DATA = () => {
    FETCH_ALL_MEMBER_POSITION_IN_ORGANISATION(organisationId)
      .then((data) => {
        dispatch(setMemberPositions(data));
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    FETCH_DATA();
  }, [organisationId]);

  useEffect(() => {
    if (memberPositions) {
      const columns = handleColumnCsv(memberPositions);
      setCsv({
        ...csv,
        data: columns,
      });
    }
  }, [memberPositions]);

  useEffect(() => {
    if (csvExportData.length > 0) {
      const columns = handleColumnCsv(csvExportData);
      setCsv({
        ...csv,
        data: columns,
      });
    }
  }, [csvExportData]);

  useEffect(() => {
    const newDoc = [];
    memberPositions?.forEach((ele, index) => {
      let data = {
        _id: ele?._id,
        title: `${ele?.description}`,
        description: `${ele?.status ? "Active" : "Inactive"}`,
      };
      newDoc.push(data);
    });
    setDataList(newDoc);
  }, [memberPositions]);

  return (
    <div className="table-organisations table-payments">
      <div className="table-layouts">
        <div className="tables">
          <StandardTableLayout
            csvHeader={csv.headers || null}
            csvData={csv.data || null}
            csvFileName={csv.fileName || null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Position" }]}
            dataSource={memberPositions}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETING_MEMBER_POSITION}
            table="team/positions"
          />
        </div>
        <div className="table-lists">
          <StandardListLayout
            csvHeader={csv.headers || null}
            csvData={csv.data || null}
            csvFileName={csv.fileName || null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Position" }]}
            dataList={dataList}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETING_MEMBER_POSITION}
            table="team/positions"
          />
        </div>
      </div>
    </div>
  );
};

export default Positions;
